import { EventSourceService } from './SSEService.common';
import { SsePlatforms } from './types';

const SSEService = new EventSourceService(SsePlatforms.WEB);

export default SSEService;
